import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "review-stars" }

import { computed, ref } from 'vue';
import ReviewStar from './ReviewStar.vue'; // Adjust the import path as necessary


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewStars',
  props: {
  rating: {
    type: Number,
    default: 5,
  },
},
  setup(__props) {

const props = __props



const stars = computed(() =>
  Array.from({ length: 5 }, (_, index) => {
    const fillValue = getStarFillValue(index);
    return { fillValue };
  })
);


function getStarFillValue(index: number) {
  if (index < Math.floor(props.rating)) {
    return 1;
  } else if (index < Math.ceil(props.rating)) {
    return props.rating - Math.floor(props.rating);
  } else {
    return 0;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stars), (star, index) => {
      return (_openBlock(), _createBlock(ReviewStar, {
        key: Date.now() + index,
        filledStar: star.fillValue
      }, null, 8, ["filledStar"]))
    }), 128))
  ]))
}
}

})